define("shared/components/shared/credentials/instagram-auth-status", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _setCloseTime;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showInstagramAuthStatusModal}}
    <Shared::Modal
      @close={{this.closeModal}}
      class="qa--cred_refresh_modal"
      {{did-insert this.updateNextDisplayDate}}
      as |modal|
    >
      <modal.card @closeIcon={{true}} @portrait={{true}}>
        <modal.card-header class="u--p__b__xs">
          {{#if this.isSuccess}}
            <h2 class="o--modalHeader__title">
              {{t "credentials.instagram_auth_status.success"}}
            </h2>
          {{else}}
            <h2 class="o--modalHeader__title">
              {{t "credentials.instagram_auth_status.title"}}
            </h2>
            <p class="u--p__t__xs">
              {{t "credentials.instagram_auth_status.subcopy"}}
            </p>
          {{/if}}
          <hr />
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          <div class="u--row u--row--noCollapse u--m__b">
            <div class="u--col__7">
              <p class={{concat-classes "u--m__b__xs u--text--bold" (unless this.isSuccess "u--text--danger")}}>
                {{this.unavailableProfiles}}
              </p>
              <p>{{t "credentials.instagram_auth_status.once_refreshed"}}</p>
            </div>
            {{#unless this.isSuccess}}
              <div class="u--col__5">
                <Shared::Ui::Button
                  @additional="block"
                  @isDisabled={{this.refreshSocialProfiles.isRunning}}
                  @promise={{this.refreshSocialProfiles}}
                  @size="large"
                  @variant="primary"
                >
                  {{#if this.refreshSocialProfiles.isRunning}}
                    {{t "shared_words.refreshing"}}
                  {{else}}
                    {{#if (gt this.originalBrokenSocialProfiles.length 1)}}
                      {{t "credentials.instagram_auth_status.refresh_all"}}
                    {{else}}
                      {{t "shared_words.refresh"}}
                    {{/if}}
                    {{svg-jar "refresh" class="o--icon u--m__l__xs"}}
                  {{/if}}
                </Shared::Ui::Button>
              </div>
            {{/unless}}
          </div>
          {{#each this.originalBrokenSocialProfiles as |originalBrokenSocialProfiles|}}
            <Shared::Credentials::InstagramAuthStatus::SocialProfileItem
              @isRunning={{this.refreshSocialProfiles.isRunning}}
              @socialProfile={{originalBrokenSocialProfiles}}
            />
          {{/each}}
          {{#if this.needsProfileRefresh}}
            <div class="u--m__t">
              {{#if this.showHelpLink}}
                <p class="u--text--right u--m__b__xs">
                  <Shared::Link
                    @href="https://help.later.com/hc/en-us/articles/360050382474"
                    @text={{t "credentials.instagram_auth_status.help_link"}}
                  />
                </p>
              {{/if}}
              <p class="u--float--right u--text--sm u--text--light u--m__b__xs">
                {{t "credentials.instagram_auth_status.show_next_time" day=this.nextCredentialDisplayDate}}
              </p>
            </div>
          {{/if}}
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @additional="block"
            @onClick={{this.closeModal}}
            @text={{t "shared_words.close"}}
            @variant="outline"
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "suQyCQ02",
    "block": "[[[41,[30,0,[\"showInstagramAuthStatusModal\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"qa--cred_refresh_modal\"],[4,[38,2],[[30,0,[\"updateNextDisplayDate\"]]],null]],[[\"@close\"],[[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[true,true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__xs\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSuccess\"]],[[[1,\"          \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"credentials.instagram_auth_status.success\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"credentials.instagram_auth_status.title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"credentials.instagram_auth_status.subcopy\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[10,\"hr\"],[12],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__b\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__7\"],[12],[1,\"\\n            \"],[10,2],[15,0,[28,[37,4],[\"u--m__b__xs u--text--bold\",[52,[51,[30,0,[\"isSuccess\"]]],\"u--text--danger\"]],null]],[12],[1,\"\\n              \"],[1,[30,0,[\"unavailableProfiles\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,3],[\"credentials.instagram_auth_status.once_refreshed\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isSuccess\"]]],[[[1,\"            \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n              \"],[8,[39,6],null,[[\"@additional\",\"@isDisabled\",\"@promise\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"refreshSocialProfiles\",\"isRunning\"]],[30,0,[\"refreshSocialProfiles\"]],\"large\",\"primary\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"refreshSocialProfiles\",\"isRunning\"]],[[[1,\"                  \"],[1,[28,[35,3],[\"shared_words.refreshing\"],null]],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,0,[\"originalBrokenSocialProfiles\",\"length\"]],1],null],[[[1,\"                    \"],[1,[28,[35,3],[\"credentials.instagram_auth_status.refresh_all\"],null]],[1,\"\\n\"]],[]],[[[1,\"                    \"],[1,[28,[35,3],[\"shared_words.refresh\"],null]],[1,\"\\n\"]],[]]],[1,\"                  \"],[1,[28,[35,8],[\"refresh\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n\"]],[]]],[1,\"              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"originalBrokenSocialProfiles\"]]],null]],null],null,[[[1,\"          \"],[8,[39,11],null,[[\"@isRunning\",\"@socialProfile\"],[[30,0,[\"refreshSocialProfiles\",\"isRunning\"]],[30,2]]],null],[1,\"\\n\"]],[2]],null],[41,[30,0,[\"needsProfileRefresh\"]],[[[1,\"          \"],[10,0],[14,0,\"u--m__t\"],[12],[1,\"\\n\"],[41,[30,0,[\"showHelpLink\"]],[[[1,\"              \"],[10,2],[14,0,\"u--text--right u--m__b__xs\"],[12],[1,\"\\n                \"],[8,[39,12],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360050382474\",[28,[37,3],[\"credentials.instagram_auth_status.help_link\"],null]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,2],[14,0,\"u--float--right u--text--sm u--text--light u--m__b__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"credentials.instagram_auth_status.show_next_time\"],[[\"day\"],[[30,0,[\"nextCredentialDisplayDate\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,6],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"closeModal\"]],[28,[37,3],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"modal\",\"originalBrokenSocialProfiles\"],false,[\"if\",\"shared/modal\",\"did-insert\",\"t\",\"concat-classes\",\"unless\",\"shared/ui/button\",\"gt\",\"svg-jar\",\"each\",\"-track-array\",\"shared/credentials/instagram-auth-status/social-profile-item\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/credentials/instagram-auth-status.hbs",
    "isStrictMode": false
  });
  let InstagramAuthStatusComponent = _exports.default = (_dec = (0, _service.service)('social/instagram-auth'), (_class = (_setCloseTime = /*#__PURE__*/new WeakSet(), class InstagramAuthStatusComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _setCloseTime);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor6, this);
      _initializerDefineProperty(this, "isSuccess", _descriptor7, this);
      _initializerDefineProperty(this, "nextCredentialDisplayDate", _descriptor8, this);
      _initializerDefineProperty(this, "originalBrokenSocialProfiles", _descriptor9, this);
      _defineProperty(this, "MAX_EXPIRY_TIME_IN_HOURS", 720);
      _defineProperty(this, "refreshSocialProfiles", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            // Note: Only Facebook Token needs update
            if (this.isMissingUserFacebookToken && !this.socialProfiles?.filter(socialProfile => socialProfile.needsRefresh).length) {
              yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
                refreshSocialProfiles: []
              });
              if (!this.isMissingUserFacebookToken) {
                this.isSuccess = true;
              }
              return;
            }

            // Note: Attempt to update all broken social profiles
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: this.brokenSocialProfiles
            });
            if (!this.socialProfiles?.filter(socialProfile => socialProfile.needsRefresh).length) {
              this.isSuccess = true;
            }
          } catch (error) {
            this.errors.log('@component:instagram-auth-status | Unable to refreshSocialProfiles', error);
          }
        }
      }), null, "refreshSocialProfiles", null));
      this.initInstagramAuthStatus();
    }
    get showInstagramAuthStatusModal() {
      return this.isMissingUserFacebookToken || this.needsProfileRefresh;
    }
    get isMissingUserFacebookToken() {
      return Boolean(!this.auth.currentUserModel?.facebookToken) && Boolean(this.socialProfiles?.length);
    }
    get socialProfiles() {
      const socialProfiles = this.args.socialProfile ? [this.args.socialProfile] : this.auth.currentGroup?.instagramProfiles;
      return socialProfiles?.filter(socialProfile => !socialProfile.isInstagramLogin);
    }
    get brokenSocialProfiles() {
      if (!this.socialProfiles) {
        return [];
      }
      if (this.isMissingUserFacebookToken) {
        return this.socialProfiles;
      }
      return this.socialProfiles.filter(socialProfile => socialProfile.needsRefresh);
    }
    get needsProfileRefresh() {
      return Boolean(this.originalBrokenSocialProfiles.length);
    }
    get actionsNeeded() {
      if (this.isMissingUserFacebookToken && this.needsProfileRefresh) {
        return 'connect & refresh';
      }
      return this.isMissingUserFacebookToken ? 'connect' : 'refresh';
    }
    get nextKey() {
      return this.instagramAuth.nextKey;
    }
    get prevKey() {
      return this.instagramAuth.prevKey;
    }
    get unavailableProfiles() {
      return this.intl.t('credentials.instagram_auth_status.unavailable_profiles', {
        count: this.originalBrokenSocialProfiles.length
      });
    }
    get showHelpLink() {
      return Boolean(this.instagramAuth.facebookPages) && this.originalBrokenSocialProfiles.any(originalBrokenSocialProfile => originalBrokenSocialProfile.needsRefresh);
    }
    initInstagramAuthStatus() {
      this.isSuccess = false;
      this.originalBrokenSocialProfiles = this.brokenSocialProfiles;
      this.segment.track('viewed-credential-status', {
        page: this.args.source,
        action_needed: this.actionsNeeded
      });
    }
    closeModal() {
      if (this.isSuccess) {
        this.instagramAuth.resetInstagramAuthStatusDates();
      } else {
        _classPrivateMethodGet(this, _setCloseTime, _setCloseTime2).call(this);
      }
      this.originalBrokenSocialProfiles = [];
      this.isSuccess = false;
      this.args.closeModal();
    }
    updateNextDisplayDate() {
      const prevCredentialDisplayDate = this.cache.retrieve(this.nextKey);
      if (typeof prevCredentialDisplayDate === 'number') {
        this.nextCredentialDisplayDate = prevCredentialDisplayDate + 1;
      } else {
        this.cache.add(this.nextKey, 0, {
          expiry: this.cache.expiry(30, 'day'),
          persist: true
        });
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isSuccess", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "nextCredentialDisplayDate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 1;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "originalBrokenSocialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateNextDisplayDate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateNextDisplayDate"), _class.prototype)), _class));
  function _setCloseTime2() {
    this.cache.add(this.prevKey, (0, _timeFormat.timestamp)(), {
      expiry: this.cache.maxExpiryDate(),
      persist: true
    });
    const prevShownTime = this.cache.retrieve(this.nextKey);
    this.cache.add(this.nextKey, typeof prevShownTime === 'number' ? prevShownTime + 1 : 0, {
      expiry: this.cache.expiry(30, 'day'),
      persist: true
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InstagramAuthStatusComponent);
});